import { takeLatest, put, call } from "redux-saga/effects";

import {
  ADD_DEVICES,
  GET_DEVICES,
  UNPAIR_DEVICES,
  UPDATE_DEVICES,
} from "./actionTypes";
import {
  getDevicesSuccess,
  getDevicesFail,
  addDevicesSuccess,
  addDevicesFail,
  unpairDevicesSuccess,
  unpairDevicesFail,
} from "./actions";

import {
  apiGetDevices,
  apiPutDevices,
  apiPatchDevices,
  apiUnPairDevices,
} from "../../helpers/api/devices";

function* onGetDevices(payload) {
  try {
    const response = yield call(apiGetDevices, payload?.payload);
    yield put(getDevicesSuccess(response?.data));
  } catch (error) {
    yield put(getDevicesFail(error.response));
  }
}
function* onAddDevices(payload) {
  try {
    const response = yield call(apiPutDevices, payload?.payload);
    console.log("responsexxx", response);
    yield put(
      addDevicesSuccess({
        message: response.data?.message || "",
        type: "ADD",
      })
    );
    const responseGet = yield call(apiGetDevices);
    yield put(getDevicesSuccess(responseGet?.data));
  } catch (error) {
    console.log("errorxxx", error);
    yield put(addDevicesFail(error?.data?.error || { type: "ADD", code: 400 }));
  }
}
function* onUpdateDevices(payload) {
  try {
    const response = yield call(
      apiPatchDevices,
      payload?.payload.id,
      payload?.payload?.data
    );
    yield put(
      addDevicesSuccess({
        message: response.data?.message || "",
        type: "UPDATE",
      })
    );
    const responseGet = yield call(apiGetDevices);
    yield put(getDevicesSuccess(responseGet?.data));
  } catch (error) {
    yield put(
      addDevicesFail(error?.data?.error || { type: "UPDATE", code: 400 })
    );
  }
}
function* onUnpairDevices(payload) {
  try {
    const response = yield call(
      apiUnPairDevices,
      payload?.payload.id,
      payload?.payload?.data
    );
    console.log("response111", response);
    yield put(
      unpairDevicesSuccess({
        message: response.data?.message || "",
        type: "UNPAIR",
      })
    );
    const responseGet = yield call(apiGetDevices);
    yield put(getDevicesSuccess(responseGet?.data));
  } catch (error) {
    console.log("error111", error);
    yield put(
      unpairDevicesFail(error?.data?.error || { type: "UNPAIR", code: 400 })
    );
  }
}
function* DeviceSaga() {
  yield takeLatest(GET_DEVICES, onGetDevices);
  yield takeLatest(ADD_DEVICES, onAddDevices);
  yield takeLatest(UPDATE_DEVICES, onUpdateDevices);
  yield takeLatest(UNPAIR_DEVICES, onUnpairDevices);
}

export default DeviceSaga;
